<div class="modal-header">
  <h4 class="modal-title pull-left">{{ 'electronic_invoicing_info.title' | translate }}</h4>
</div>

<div class="modal-body electronic-invoicing-info-body">
  <p>{{ 'electronic_invoicing_info.intro' | translate }}</p>

  <h5 class="subtitle">{{ 'electronic_invoicing_info.option_pa_title' | translate }}</h5>
  <p>{{ 'electronic_invoicing_info.option_pa_body' | translate }}</p>
  <p>{{ 'electronic_invoicing_info.option_pa_rules_intro' | translate }}</p>
  <p>{{ 'electronic_invoicing_info.option_pa_rules_case' | translate }}</p>
  <ol>
    <li>
      <strong>{{ 'electronic_invoicing_info.rule_activity_id_label' | translate }}</strong>
      {{ 'electronic_invoicing_info.rule_activity_id' | translate }}
    </li>
    <li>
      <strong>{{ 'electronic_invoicing_info.rule_amounts_label' | translate }}</strong>
      {{ 'electronic_invoicing_info.rule_amounts' | translate }}
    </li>
    <li>
      <strong>{{ 'electronic_invoicing_info.rule_address_label' | translate }}</strong>
      <span class="copyable-address" (click)="copyAddress()"
            [tooltip]="'electronic_invoicing_info.copy' | translate"
            container="body">
        <code>{{ electronicAddress }}</code>
        <fa-icon class="copy-icon" [icon]="faCopy"></fa-icon>
      </span>
    </li>
  </ol>

  <h5 class="subtitle">{{ 'electronic_invoicing_info.option_classic_title' | translate }}</h5>
  <p>{{ 'electronic_invoicing_info.option_classic_body' | translate }}</p>
  <p>{{ 'electronic_invoicing_info.option_classic_rules_intro' | translate }}</p>
  <p>{{ 'electronic_invoicing_info.option_classic_rules_case' | translate }}</p>
  <ol>
    <li>
      <strong>{{ 'electronic_invoicing_info.rule_classic_deposit_label' | translate }}</strong>
      {{ 'electronic_invoicing_info.rule_classic_deposit' | translate }}
    </li>
    <li>
      <strong>{{ 'electronic_invoicing_info.rule_classic_address_label' | translate }}</strong>
      {{ 'electronic_invoicing_info.rule_classic_address' | translate }}
    </li>
  </ol>

  <p>
    <a [href]="'mailto:' + contactEmail">{{ 'electronic_invoicing_info.contact_us' | translate }}</a>
  </p>
</div>

<div class="modal-footer">
  <isp-button
    [type]="ButtonTypeEnum.CLASSIC"
    [colour]="IspColoursEnum.primary"
    [text]="'electronic_invoicing_info.got_it'"
    [disabled]="submitting"
    (trigger)="acknowledge()"
  ></isp-button>
</div>
